// Zoeken (Ctrl+K): elk zoekwoord moet ergens in naam, onderregel of soort voorkomen. Geen losse
// letters zoals cmdk standaard doet ("Teststraat" mag "Ter ondertekening versturen" niet vinden).
// Begint de naam met het eerste zoekwoord, dan komt het resultaat bovenaan.

export function matchWords(_value: string, search: string, keywords: string[] = []) {
  const text = keywords.join(" ").toLocaleLowerCase("nl-BE");
  const words = search.toLocaleLowerCase("nl-BE").split(/\s+/).filter(Boolean);
  if (!words.every((word) => text.includes(word))) return 0;
  return (keywords[0] ?? "").toLocaleLowerCase("nl-BE").startsWith(words[0] ?? "") ? 1 : 0.5;
}
